/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Campus } from './campus';
import { TrainingTypeEnum } from './trainingTypeEnum';
import { Organisation } from './organisation';
import { TrainingPlanTypeEnum } from './trainingPlanTypeEnum';
import { EducationTypeEnum } from './educationTypeEnum';
import { TrainingDomain } from './trainingDomain';
import { TrainingClass } from './trainingClass';
import { TrainingChecklist } from './trainingChecklist';
import { TrainingResearchType } from './trainingResearchType';
import { Department } from './department';
import { Language } from './language';
import { TrainingGoal } from './trainingGoal';
import { TrainingReflectionType } from './trainingReflectionType';
import { TrainingClassGroup } from './trainingClassGroup';
import { TrainingLogbookType } from './trainingLogbookType';
import { LocationTypeEnum } from './locationTypeEnum';
import { TrainingSupervisorType } from './trainingSupervisorType';
import { TrainingAssessmentType } from './trainingAssessmentType';
import { TrainingSurveyType } from './trainingSurveyType';
import { CompetencesEnum } from './competencesEnum';


/**
 * 
 */
export interface PartialTraining { 
    /**
     * 
     */
    id?: number;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    studyPoints?: number;
    /**
     * 
     */
    code?: string;
    type?: TrainingTypeEnum;
    planType?: TrainingPlanTypeEnum;
    /**
     * 
     */
    planDescription?: string;
    organisation?: Organisation;
    /**
     * 
     */
    supervisorTypes?: Array<TrainingSupervisorType>;
    /**
     * 
     */
    name_du?: string;
    /**
     * 
     */
    name_nl?: string;
    /**
     * 
     */
    name_fr?: string;
    /**
     * 
     */
    name_en?: string;
    /**
     * 
     */
    competenceLabel?: string;
    /**
     * 
     */
    competenceLabelDu?: string;
    /**
     * 
     */
    competenceLabelNl?: string;
    /**
     * 
     */
    competenceLabelFr?: string;
    /**
     * 
     */
    competenceLabelEn?: string;
    /**
     * 
     */
    maxYears?: number;
    locationType?: LocationTypeEnum;
    /**
     * 
     */
    trainingYearKeyLabel?: string;
    educationType?: EducationTypeEnum;
    competences?: CompetencesEnum;
    /**
     * 
     */
    assessmentTypes?: Array<TrainingAssessmentType>;
    /**
     * 
     */
    reflectionTypes?: Array<TrainingReflectionType>;
    /**
     * 
     */
    logbookTypes?: Array<TrainingLogbookType>;
    /**
     * 
     */
    researchTypes?: Array<TrainingResearchType>;
    /**
     * 
     */
    surveyTypes?: Array<TrainingSurveyType>;
    /**
     * 
     */
    apiAvailable?: boolean;
    /**
     * 
     */
    canInviteTeamAccounts?: boolean;
    /**
     * 
     */
    hasBulletinBoard?: boolean;
    /**
     * 
     */
    canExportData?: boolean;
    /**
     * 
     */
    lnk_org_id?: number;
    /**
     * 
     */
    trainingGroup?: string;
    /**
     * 
     */
    trainingGroupDescr?: string;
    /**
     * 
     */
    orgName?: string;
    /**
     * 
     */
    departments?: Array<Department>;
    /**
     * 
     */
    goals?: Array<TrainingGoal>;
    /**
     * 
     */
    trainingPlanAvailable?: boolean;
    /**
     * 
     */
    assessmentsAvailable?: boolean;
    /**
     * 
     */
    logbooksAvailable?: boolean;
    /**
     * 
     */
    domainsAvailable?: boolean;
    /**
     * 
     */
    domains?: Array<TrainingDomain>;
    /**
     * 
     */
    classes?: Array<TrainingClass>;
    /**
     * 
     */
    classGroups?: Array<TrainingClassGroup>;
    /**
     * 
     */
    checklist?: Array<TrainingChecklist>;
    /**
     * 
     */
    checklistAvailable?: boolean;
    /**
     * 
     */
    documentsAvailable?: boolean;
    /**
     * 
     */
    reflectionsAvailable?: boolean;
    /**
     * 
     */
    goalsAvailable?: boolean;
    /**
     * 
     */
    epasAvailable?: boolean;
    /**
     * 
     */
    classesAvailable?: boolean;
    /**
     * 
     */
    researchAvailable?: boolean;
    /**
     * 
     */
    questionListsAvailable?: boolean;
    /**
     * 
     */
    casesAvailable?: boolean;
    /**
     * 
     */
    learningAgendaAvailable?: boolean;
    /**
     * 
     */
    campusesAvailable?: boolean;
    /**
     * 
     */
    locationDepartments?: boolean;
    /**
     * 
     */
    internshipSupervisorsPerInternship?: PartialTraining.InternshipSupervisorsPerInternshipEnum;
    /**
     * 
     */
    status?: boolean;
    /**
     * 
     */
    createTS?: string;
    /**
     * 
     */
    editTS?: string;
    /**
     * 
     */
    editSubscriptionId?: number;
    /**
     * 
     */
    languages?: Array<Language>;
    /**
     * 
     */
    campuses?: Array<Campus>;
}
export namespace PartialTraining {
    export type InternshipSupervisorsPerInternshipEnum = 'multiple' | 'single';
    export const InternshipSupervisorsPerInternshipEnum = {
        Multiple: 'multiple' as InternshipSupervisorsPerInternshipEnum,
        Single: 'single' as InternshipSupervisorsPerInternshipEnum
    };
}


